import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getLoggedAtWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.LOGGED_AT)
}

export default getLoggedAtWorkoutUtil
